<template>
    <div class="hotel-block" v-if="visible">
        <div class="hotel-block-title">
            <div class="order-number">{{$t('order_sn')}}：{{order_sn}}</div>
            <div class="order-status">{{status_msg}}</div>
        </div>
        <div class="hotel-block-content">
            <div class="hotel-block-img"></div>
            <div class="block-content">
                <h3 class="content-title">{{hotel_name}}</h3>
                <star :level="hotel_star"></star>
                <p class="content-text">{{hotel_addr}}, {{city_name}}, {{city_name}}</p>
                <div class="booking-info">
                    <span>{{room_type}} {{room_count}}{{$t('room')}} {{dur}}{{$t('night')}}</span>
                    <span>{{$t('check_in_date')}}: {{startDate}}</span>
                    <span>{{$t('check_out_date')}}: {{endDate}}</span>
                </div>
            </div>
        </div>
        <div class="hotel-block-footer">
            <button
                class="btn-primary"
                @click="toPay"
            >{{$t('pay')}} {{currency}} {{amount}} ({{$t('remaining')}} {{remaining}})</button>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import Star from "@/components/Star.vue";
import { linkTo } from "@/lib/utils";

export default {
    props: [
        "order_sn",
        "status_msg",
        "hotel_name",
        "currency",
        "amount",
        "room_type",
        "room_count",
        "dur",
        "start_time",
        "end_time",
        "expire_time",
        "hotel_addr",
        "country_name",
        "city_name",
        "hotel_star"
    ],
    components: {
        Star
    },
    computed: {
        startDate() {
            return moment(this.start_time * 1000).format("YYYY-MM-DD");
        },
        endDate() {
            return moment(this.end_time * 1000).format("YYYY-MM-DD");
        }
    },
    data() {
        return {
            remaining: 0,
            visible: true //是否显示
        };
    },
    mounted() {
        //倒计时
        let expireTime = this.expire_time;
        this.countDown(expireTime);
        let clock = setInterval(() => {
            if (expireTime === 0) {
                clearInterval(clock);
                this.visible = false;
                return;
            }
            this.countDown(expireTime);
            expireTime--;
        }, 1000);
    },
    methods: {
        /**
         * @param {Number} expireTime 秒数
         */
        countDown(expireTime) {
            let minitue = Math.floor(expireTime / 60);
            let seconds = expireTime % 60;
            this.remaining = `${minitue < 10 ? "0" + minitue : minitue}:${
                seconds < 10 ? "0" + seconds : seconds
            }`;
        },

        /**
         * 跳转支付
         */
        toPay() {
            this.$local.remove("pending.data");
            this.$local.set("pending.data", {
                check_in: this.startDate,
                check_out: this.endDate,
                roomName: this.room_type,
                hotel_name: this.hotel_name,
                room_count: this.room_count,
                dur: this.dur
            });

            linkTo(
                `/payment?type=order&price=${this.amount}&currency=${this.currency}&order_sn=${this.order_sn}`
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.hotel-block {
    width: 930px;
    margin: 20px auto;
    box-sizing: border-box;
    border: 1px solid #eee;
    background-color: #fff;
    color: #484848;
    .hotel-block-title {
        box-sizing: border-box;
        padding: 15px 30px;
        display: flex;
        justify-content: space-between;
        .order-status {
            color: #00a9ba;
        }
    }
    .hotel-block-content {
        display: flex;
        box-sizing: border-box;
        padding: 30px;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        .hotel-block-img {
            width: 170px;
            height: 120px;
            background-size: cover;
            background-position: center;
            background-image: url("https://g1.ifreegroup.co/ebbly/ebbly.png");
        }
        .block-content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            box-sizing: border-box;
            flex: 1;
            padding-left: 30px;
            .content-title {
                margin: 0;
                font-size: 24px;
                color: #484848;
            }
            .content-text {
                color: #767676;
                font-size: 14px;
            }
            .booking-info {
                display: flex;
                justify-content: space-between;
                font-size: 16px;
                color: #484848;
            }
        }
    }
    .hotel-block-footer {
        padding: 20px 0;
        text-align: center;
        .btn-primary {
            box-sizing: border-box;
            height: 40px;
            width: 320px;
            border: none;
            border-radius: 45px;
            background: linear-gradient(90deg, #52d6ce 0%, #00a9ba 100%);
            cursor: pointer;
            transition: all ease-in-out 0.2s;
            &:active {
                opacity: 0.7;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Public/components/HotelBlock.vue